var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.375C5.57812 0.375 0.375 5.57812 0.375 12C0.375 18.4219 5.57812 23.625 12 23.625C18.4219 23.625 23.625 18.4219 23.625 12C23.625 5.57812 18.4219 0.375 12 0.375ZM12 22.125C6.42188 22.125 1.875 17.625 1.875 12C1.875 6.46875 6.375 1.875 12 1.875C17.5312 1.875 22.125 6.42188 22.125 12C22.125 17.5781 17.5781 22.125 12 22.125ZM16.4062 8.76562C16.6406 8.53125 16.6406 8.20312 16.4062 7.96875L16.0312 7.59375C15.7969 7.35938 15.4688 7.35938 15.2344 7.59375L12 10.8281L8.71875 7.59375C8.53125 7.35938 8.15625 7.35938 7.92188 7.59375L7.54688 7.96875C7.3125 8.20312 7.3125 8.53125 7.54688 8.76562L10.7812 12L7.54688 15.2812C7.3125 15.4688 7.3125 15.8438 7.54688 16.0781L7.92188 16.4531C8.15625 16.6875 8.53125 16.6875 8.71875 16.4531L12 13.2188L15.2344 16.4531C15.4688 16.6875 15.7969 16.6875 16.0312 16.4531L16.4062 16.0781C16.6406 15.8438 16.6406 15.4688 16.4062 15.2812L13.1719 12L16.4062 8.76562Z",
    fill: "#323232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRemove);
export default __webpack_public_path__ + "static/media/plus-remove.7abef3d81c2b48d379c4af505ba3c0fb.svg";
export { ForwardRef as ReactComponent };